module.exports = __webpack_public_path__ + "static/media/comment5_3.1034c3a8.png";